<router-outlet></router-outlet>
<ngx-ui-loader fgsColor="#FFBC00" text="Cargando..." textColor="#FFBC00"></ngx-ui-loader>
